<template>
  <div class="d-flex justify-start flex-column" :style="[
      {
        backgroundColor: '#F4F4F4',
        borderRadius: '0',
        padding: `48px ${$globalSideMargin}`,
        maxHeight: '703px',
        overflowY: 'auto',
        overflowX: 'hidden'
      },
      $breakpoints.mdAndUp && {
        borderRadius: $getScaledCssValue('6px'),
        height: 'auto',
        padding: `${$getScaledCssValue('29px')} 4px ${$getScaledCssValue(
          '21px'
        )} 0`
      }
    ]">

    <!-- Actual filters -->
    <template v-if="sidebarData">
      <!--<v-expansion-panels accordion>
        <v-expansion-panel
          data-cy="list-sidebar-expansion-panel"
          v-for="(itemObject, index) in itemObjects"
          :key="itemObject.filterObj.title + index"
          class="expansion-panel"
        >
          <template v-if="itemObject.filterObj">
            <v-expansion-panel-header class="expansion-panel-header">
              <template #default="{ open }">
                <div
                  class="d-flex align-baseline filter-menu-activator"
                  :style="[
                    {
                      marginBottom: '2px'
                    },
                    $breakpoints.mdAndUp && {
                      padding: `0 ${$getScaledCssValue('22px')}`
                    }
                  ]"
                >
                  <v-icon color="primary" :size="14">{{
                    open ? 'mdi-minus-box' : 'mdi-plus-box'
                  }}</v-icon>

                  <div
                    class="filter-item-label text-p3"
                    :style="{
                      marginLeft: $getScaledCssValue('6px')
                    }"
                  >
                    {{ itemObject.filterObj.title }} 
                  </div>
                </div>
              </template>
            </v-expansion-panel-header>

            <v-expansion-panel-content
              class="expansion-panel-content no-padding"
              :style="{ marginLeft: $getScaledCssValue('46px') }"
            >-->
      <!-- Inner panel -->
      <!--<v-expansion-panels accordion>
                <v-expansion-panel
                  v-for="(filterItem, index) in itemObject.filterObj.filters"
                  :key="index"
                  class="expansion-panel"
                >
                  <v-expansion-panel-header class="expansion-panel-header">
                    <template #default="{ open }">
                      <div
                        class="d-flex align-baseline filter-menu-activator"
                        :style="{
                          marginBottom: '2px'
                          //padding: `0 ${$getScaledCssValue('22px')}`
                        }"
                      >
                        <v-icon color="primary" :size="14">{{
                          open ? 'mdi-minus-box' : 'mdi-plus-box'
                        }}</v-icon>
                        <div
                          class="filter-item-label text-p3"
                          :style="{
                            marginLeft: $getScaledCssValue('6px')
                          }"
                        >
                          {{ filterItem.label }}
                        </div>
                      </div>
                    </template>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content
                    class="expansion-panel-content no-padding"
                  >-->
      <div class="filter-item-label text-p3" :style="{
                            marginLeft: $getScaledCssValue('22px'),
                            color:'#B38D3D',
                            fontWeight: 'bold',
                          }">
        {{ $t("categoriesSectionTitle") }}

        <div :style="{
                        padding: `10px 0 0 10px`
                      }">
          <Checkbox v-for="(item, index) in sidebarData" :key="item.name + index" :val="item.name"
            class="filter-checkbox checkbox" dense v-model="selectedSidebarItems" color="green"
            :ripple="false" :style="{
                          marginTop: '2px',
                          backgroundColor: '#f5f5f5'
                        }">
            <template #label>
              <div class="text-p5 d-flex font-weight-light">
                {{ item.name }}
                <div :style="{
                  backgroundColor: '#50753611', 
                  color: '#507536',        
                  borderRadius: '6px',     /* Rounded corners */
                  padding: '2px 8px',       /* Inner padding */
                  marginLeft: '8px',        /* Spacing between name and count */
                  fontWeight: 'bold',
                  fontSize: '12px'          /* Adjust font size */
                }">
                  {{ item.count }}
                </div>
              </div>
            </template>
          </Checkbox>
        </div>
      </div>
      <!--
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </template>
        </v-expansion-panel>
      </v-expansion-panels>-->
    </template>

    <template v-else>
      <SkeletonLoader data-cy="list-sidebar-loader" v-for="n in 6" :key="n" type="text" :style="{
          marginBottom: '2px',
          padding: `0 ${$getScaledCssValue('22px')}`
        }" />
    </template>
  </div>
</template>

<script>
import Checkbox from './Checkbox.vue';
import AutoComplete from './AutoComplete.vue';
import TextField from '../inputs/TextField.vue';
import SkeletonLoader from '../Utils/SkeletonLoader.vue'
export default {
  components: {
    Checkbox,
    AutoComplete,
    TextField,
    SkeletonLoader
  },
  props: {
    sidebarData: {
      type: Array,
      default: null
    },
  },
  data() {
    return {
      itemHeight: 32,
      selectedSidebarItems:[]
    }
  },
  methods: {
    getScrollerHeight(items) {
      const numberOfItems = items.length
      const maxNumberOfItems = 5

      if (numberOfItems < maxNumberOfItems) {
        return numberOfItems * this.itemHeight
      } else {
        return maxNumberOfItems * this.itemHeight
      }
    },
    filter() {
      const selectedFilters = []
      this.filterItems.forEach((item) => {
        selectedFilters.push({
          title: item.title,
          selectedFilters: item.selectedFilters
        })
      })
    },
  },

  watch: {
    /*
    filterItems: {
      deep: true,
      handler() {
        const selectedFilters = []
        this.filterItems.forEach((item) => {
          selectedFilters.push({
            title: item.title,
            selectedFilters: item.selectedFilters
          })
        })
      }
    }
    */
    selectedSidebarItems: {
    deep: true,
    handler(newVal) {
      this.$emit('update:selectedSidebarItems', newVal);
    },
  },
  }
}
</script>

<style scoped lang="scss">
// @import '~Scss/variables.scss';

.filter-item + .filter-item {
  margin-top: 8px;
}

.checkbox-label {
  max-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
}
/*
.filter-item-label {
  margin-top: 8px;
}
*/

.textfield::v-deep {
  & input {
    font-size: #{20px * 0.8};
  }

  & label {
    font-size: #{20px * 0.8};
  }
}

.checkbox::v-deep {
  & .v-input {
    margin-top: 0;
    padding-top: 0;
  }

  & .v-input__slot {
    margin-bottom: 0;
    align-items: start;
  }

  & .v-input--selection-controls__input {
    width: 12px;
    height: 12px;
    margin-top: 2px;
  }
}

.expansion-panel {
  background-color: transparent !important;

  &::before {
    box-shadow: none;
  }

  &::after {
    display: none;
  }
}

.expansion-panel-header {
  padding: 0;
  min-height: 0 !important;

  &::v-deep {
    & .v-expansion-panel-header__icon {
      display: none;
    }
  }
}

.expansion-panel-content {
  &::v-deep {
    no-padding,
    & .v-expansion-panel-content__wrap {
      padding: 0;
    }
  }
}
</style>
